import find from 'lodash/find';

export const getValueByID = (items: any[] = [], id: string) => {
  const obj = find(items, (item: any) => item[0] === id);

  if (obj) {
    if (typeof obj[1] === 'string') {
      return obj[1];
    } else {
      return obj[1].value;
    }
  }
  return;
};
